import React, {useState, useEffect} from 'react';
import Modal from 'react-bootstrap/Modal';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { Loading } from '~/components';
import { FormCad } from '../components';
import initialData from './initialData';
import schema from './schema'
import { Button } from 'react-bootstrap';
import { updateAlternativaQuestaoAnalise, loadAlternativaQuestaoAnalises, showAlternativaQuestaoAnalise  } from '~/store/modules/alternativa_questao_analise/action';


const Edit = () => {
  let history = useHistory();
  const [AlternativaEdit, setAlternativaEdit] = useState(initialData);
  const [errorsValidate, setErrorsValidate] = useState([]);
  const [updated, setUpdated] = useState(false);
  const dispatch = useDispatch();
  const { questao_analise_id, id_alternativa } = useParams();
  const { alternativa_questao_analise, errors } = useSelector(({ AlternativaQuestaoAnaliseReducer }) => AlternativaQuestaoAnaliseReducer);


  useEffect(() => {
    dispatch(showAlternativaQuestaoAnalise(id_alternativa));
  }, [dispatch, id_alternativa]);

  useEffect(() => {
    if (alternativa_questao_analise.id === parseInt(id_alternativa)) {
      setAlternativaEdit(alternativa_questao_analise);
    }
  }, [alternativa_questao_analise, id_alternativa]);

  useEffect(() => {
    if (errors.status && errors.status === 422) {
      let server_errors = {};
      const response_errors = errors.data.errors;
      for (let name of Object.keys(response_errors)) {
        Object.assign(server_errors, { [name]: response_errors[name][0] });
      }
      setErrorsValidate(server_errors);
    }
    if(errors.update) {
      setUpdated(true);
    }
  }, [errors]);

  useEffect(() => {
    if (updated) {
      Swal.fire('Sucesso', 'Registro atualizado com sucesso!', 'success').then(
        () => {
          history.goBack();
        }
      );
    }
  }, [updated, history, dispatch, id_alternativa]);

  const handleClose = () => {
    history.goBack();
  };

  const handleSubmit = async event => {
    event.preventDefault();
    if (!schema.isValidSync(AlternativaEdit)) {
      let yup_errors = {};
      schema.validate(AlternativaEdit, { abortEarly: false }).catch(err => {
        for (let error of err.inner) {
          const { path, message } = error;
          Object.assign(yup_errors, { [path]: message });
        }
        setErrorsValidate(yup_errors);
      });
    } else {
      await dispatch(updateAlternativaQuestaoAnalise(AlternativaEdit, id_alternativa));
      await dispatch(loadAlternativaQuestaoAnalises({
        where: `questao_analise_id:${questao_analise_id}`
      }));
      await setUpdated(true);
    }

  };
  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="modal-xl"
      onHide={handleClose}
      show
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Indicadores Ambientais da Atividade</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Editar</h2>
          </div>
          <div className="card-body">
            {alternativa_questao_analise.id === parseInt(id_alternativa) ? (
              <FormCad
                alternativaQuestaoAnalise={AlternativaEdit}
                errors={errorsValidate}
                handleSubmit={handleSubmit}
                schema={schema}
                setAlternativaQuestaoAnalise={setAlternativaEdit}
              />
            ) : (
              <Loading />
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="btn btn-default"
          onClick={handleClose}
        >
          <i className="fa fa-window-close" /> Cancelar
        </Button>
        <button
          className="btn btn-success"
          form="form_alternativa_questao_analise"
          type="submint"
        >
          <i className="fa fa-save" /> Salvar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default Edit;
